export enum RefundStatus {
	PENDING = "PENDING",
	PROCESSING = "PROCESSING",
	SUCCESS = "SUCCESS",
	FAILED = "FAILED",
}
